/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-26 11:39:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextStyle } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { getFormValues } from 'redux-form';

import SearchPage from './search-page';
import InstantSearchWidget from './instant-search-widget';

class Preview extends Component<ComposedProps, State> {
  render() {
    const { i18n, formValues, widget, selectedPlacement } = this.props;

    return (
      <div className="visual-editor-preview-wrapper">
        <div>
          <div className="visual-editor-preview">
            {selectedPlacement.value === 'search-result-page' ? (
              <div className="recommendation-bundle">
                <SearchPage formValues={formValues} widget={widget} />
              </div>
            ) : (
              <InstantSearchWidget formValues={formValues} widget={widget} />
            )}
            <div className={`recommendation-note ${selectedPlacement.value}`}>
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.PredictiveBundle.Item.visualEditor__note1')}
              </TextStyle>
              <TextStyle variation="subdued">
                {i18n.translate('AdminHTML.PredictiveBundle.Item.visualEditor__note2')}
              </TextStyle>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, props) => {
  const formValues = getFormValues('BundleVisualEditorForm')(state);
  const tenantApp = _.get(state.oauth, 'tenantApp', {});

  return {
    formValues,
    tenantApp
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Preview));
